<template>
  <div class="invite-main">
    <div class="bg">
      <div class="main">
        <div class="banner" v-if="lang=='cn'"></div>
        <div class="banner1" v-if="lang=='hk'"></div>
      </div>
      <div class="main">
        <div class="content-detail">
          <div class="title">
            <p class="p1">{{$t('title.w62')}}</p>
            <p class="p2">
              <span>{{$t('other.w124')}}{{InvestmentAwardRate}}%</span>
            </p>
            <div class="eg" v-if="lang=='cn'" >
              <div class="example"></div>
              <!-- <div class="example ex1"></div> -->
            </div>
            <div class="eg" v-if="lang=='hk'" >
              <div class="example ex2"></div>
              <!-- <div class="example ex3"></div> -->
            </div>
            <div class="btn">
              <Button @click="()=>this.$router.push({name:'invite'})">{{$t('btn.b83')}}</Button>
            </div>
            <div class="adorn addr"></div>
            <div class="adorn addr1"></div>
          </div>
          <div class="desc">
            <p>{{$t('other.w126')}}</p>
            <p>{{$t('other.w127')}}</p>
            <p>{{$t('other.w128')}}</p>
            <p>{{$t('other.w129')}}</p>
            <p>{{$t('other.w130')}}</p>
            <p>{{$t('other.w131')}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Datatable from "@/components/datatable";
export default {
  components: { Datatable },
  data() {
    return {
      LoanAwardRate:'',
      InvestmentAwardRate:''
    };
  },
  created(){
    this.getRate()
  },
  methods:{
    getRate(){
      this.$axios.get('/Member/RZJFund/GetInvitedAwardRateConfig')
      .then(res => {
          if (res.err) return res.throw();
          this.InvestmentAwardRate = res.InvestmentAwardRate
          this.LoanAwardRate = res.LoanAwardRate
      })
    }
  },
  computed: {
    lang() {
      return this.$i18n.locale;
    }
  }
};
</script>

<style lang="less" scoped>
.invite-main {
  background: #f1f2f5;
  background: linear-gradient(
    0deg,
    rgba(120, 67, 245, 1) 46%,
    rgba(171, 99, 253, 1) 100%
  );
  .main {
    width: 1200px;
    margin: 0 auto;
  }
  .bg {
    position: relative;
    background: url("../../assets/invite/bg.png");
    background-size: 100%;
    .banner {
      background: url("../../assets/invite/banner.png");
      height: 453px;
    }
    .banner1 {
      background: url("../../assets/invite/banner1.png");
      height: 453px;
    }
  }
  .content-detail {
    width: 710px;
    margin: 0 auto;
    padding-bottom: 20px;
    .title {
      margin-top: 50px;
      // height: 464px;
      background: rgba(255, 255, 255, 1);
      border-radius: 20px;
      padding-top: 50px;
      position: relative;
      .p1 {
        margin-bottom: 50px;
        font-size: 36px;
        font-family: SourceHanSansCN-Medium;
        font-weight: bold;
        color: rgba(255, 255, 255, 1);
        line-height: 48px;
        background: linear-gradient(
          84deg,
          rgba(95, 46, 246, 1) 0%,
          rgba(186, 69, 221, 1) 100%
        );
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        text-align: center;
      }
      .p2 {
        text-align: center;
        font-size: 24px;
        font-family: SourceHanSansCN-Regular;
        font-weight: 400;
        color: rgba(95, 46, 246, 1);
        margin-bottom: 20px;
        // .s1 {
        //   display: inline-block;
        //   font-size: 28px;
        //   color: #fff;
        //   margin-right: 20px;
        //   margin-bottom: 20px;
        //   width: 44px;
        //   height: 44px;
        //   background: linear-gradient(
        //     181deg,
        //     rgba(255, 176, 232, 1) 0%,
        //     rgba(255, 112, 213, 1) 100%
        //   );
        //   border-radius: 50%;
        // }
      }
      .eg {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .example {
          width: 418px;
          height: 288px;
          background: url("../../assets/invite/active.png");
          background-size: 100%;
        }
        .ex1{
           margin-top: 30px;
           background: url("../../assets/invite/active1.png");
        }
        .ex2{
           background: url("../../assets/invite/active2.png");
        }
        .ex3{
           margin-top: 30px;
           background: url("../../assets/invite/active3.png");
        }
      }
      .btn {
        margin-top: 40px;
        display: flex;
        width: 100%;
        justify-content: center;
        /deep/.ivu-btn {
          margin-bottom: 40px;
          width: 320px;
          height: 60px;
          background: linear-gradient(
            181deg,
            rgba(255, 176, 232, 1) 0%,
            rgba(255, 112, 213, 1) 100%
          );
          border-radius: 30px;
          font-size: 30px;
          color: #fff;
          font-weight: bold;
          span {
            vertical-align: baseline;
          }
        }
      }
      .adorn {
        position: absolute;
        width: 94px;
        height: 26px;
        background: url("../../assets/invite/pc1.png");
        background-size: 100%;
      }
      .addr {
        left: -42px;
        top: 50px;
      }
      .addr1 {
        right: -45px;
        bottom: 50px;
      }
    }
    .desc {
      color: #fdfdfd;
      font-size: 14px;
      margin-top: 50px;
      p {
        margin-bottom: 10px;
      }
      p:first-child {
        font-size: 18px;
        color: #fff;
      }
      p:last-child{
        margin-bottom: 0;
      }
    }
  }
}
</style>


